import { Injectable } from '@angular/core';

import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { Observable } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class UserService {
  user: Observable<firebase.User>;

  constructor(private firebaseAuth: AngularFireAuth, private firestore: AngularFirestore) {
    this.user = firebaseAuth.authState;
  }

  signup(email: string, password: string, data: { nombre_usuar: string, ape_pat_usuar: string, ape_mat_usuar: string,
    rut_usuar: string, correo_user: string, cargo_usuar: string, perfil_usuar: string } ): any {
    return this.firebaseAuth
      .auth
      .createUserWithEmailAndPassword(email, password).then((user) => {
        return this.firestore.collection('Usuarios').doc(user.user.uid).set(data);
      });
  }
  
  edit(email: string, password: string, data: { nombre_usuar: string, ape_pat_usuar: string, ape_mat_usuar: string,
    rut_usuar: string, correo_user: string, cargo_usuar: string, perfil_usuar: string } ): any {
    return this.firebaseAuth
      .auth
      .createUserWithEmailAndPassword(email, password).then((user) => {
        return this.firestore.collection('Usuarios').doc(user.user.uid).set(data);
      });
  }

  login(email: string, password: string): any {
    return this.firebaseAuth
      .auth
      .signInWithEmailAndPassword(email, password);
  }

  forgot(email: string): any {
    return this.firebaseAuth
    .auth
    .sendPasswordResetEmail(email);
  }

  logout() {
    return this.firebaseAuth
    .auth
    .signOut();
  }
}
